<template>
  <b-overlay
    :show="busy"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <div class="email-response box-shadow">
      <b-form-input
        @keyup.enter="addEmail"
        v-model="email"
        @update="validateEmail(email)"
        type="email"
        required
        placeholder="To:"
        size="sm"
        autocomplete="off"
      ></b-form-input>
      <span v-if="!isEmail" class="email-response--red-alert"
        >Please, enter an email address.</span
      >

      <div v-if="thereIsEmails" class="email-response__copy-to-content">
        <div v-for="(email, index) in copyTo" :key="index">
          <span
            :key="email + index"
            class="email-response__copy-to-content--email box-shadow"
          >
            {{ email }}
            <button
              class="email-response__copy-to-content--close-email"
              v-bind:key="index"
              @click="deleteEmail(index)"
              type="button"
              aria-label="Close email"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </span>
        </div>
        <hr />
      </div>

      <b-form-input
        v-model="cannedResponseSelected"
        class="email-response--canned-responses"
        list="responses"
        placeholder="Canned responses"
        aria-label="Canned responses"
        autocomplete="off"
        @change="renderFtlTables"
        ref="cannedResponseSelected"
      ></b-form-input>

      <datalist id="responses">
        <option v-for="response in responses" v-bind:key="response.name">
          {{ response.name }}
        </option>
      </datalist>
      <div class="drayage-tables-container">
        <div v-for="(item, index) in this.haulInformation" :key="index">
          <Rate
            v-if="
              currentCannedResponse &&
                cannedResponseSelected.includes('DRAYAGE')
            "
            :rateTableId="index"
            :currentCannedResponse="currentCannedResponse.aditionals.rateTable"
            :haulId="haulInformation[index].id"
            @cannedResponseTable="cannedResponseTable"
          />
        </div>
        <Accessorials
          v-if="
            currentCannedResponse && cannedResponseSelected.includes('DRAYAGE')
          "
          :currentCannedResponse="
            currentCannedResponse.aditionals.accessorialTable
          "
          @cannedResponseTable="cannedResponseTable"
        />
      </div>
      <div
        class="ftl-tables-container"
        v-if="
          thereIsDedicatedQuoteInfo === true &&
            showFtlTable === true &&
            cannedResponseSelected !== '' &&
            cannedResponseSelected !== null &&
            !cannedResponseSelected.toLowerCase().match('drayage')
        "
      >
        <div :key="renderFtlTable" class="ftl-tables-container">
          <div
            v-for="(item, index) in this.haulInformation"
            :key="'ftl-table' + index"
            class="ftl-tables-container__tables-per-trip"
          >
            <p class="ftl-tables-container__title">Trip {{ index + 1 }}:</p>
            <FreightDetails
              v-if="ftlQuoteTableInfo[index] && currentCannedResponse"
              :ftlQuoteTableInformation="ftlQuoteTableInfo[index]"
              :freightTableId="index"
              :cannedResponseName="cannedResponseSelected"
              :currentCannedResponse="
                currentCannedResponse.aditionals.freightDetails
              "
              @addTableHtml="addTableHtml"
            />
            <!-- Componente que ocupa la información de los trailers -->
            <QuoteInformation
              v-if="currentCannedResponse && ftlQuoteMode[index]"
              :quoteInfoTableId="index"
              :cannedResponseName="cannedResponseSelected"
              :ftlQuoteTablesGuid="haulInformation[index].id"
              :pcmiler="haulInformation[index].pcmiler"
              :currentCannedResponse="
                currentCannedResponse.aditionals.quoteInformation
              "
              :quoteMode="ftlQuoteMode[index]"
              @addTableHtml="addTableHtml"
            />
          </div>
        </div>
      </div>

      <div class="email-response__body-message">
        <FroalaEditor v-model="messageBody" :content="newContent" />
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import FroalaEditor from "../FroalaEditor.vue";
import Rate from "@/views/InfoEmail/EmailResponseOTR/components/cannedResponsesTables/drayage/Rate.vue";
import Accessorials from "@/views/InfoEmail/EmailResponseOTR/components/cannedResponsesTables/drayage/Accessorials.vue";
import QuoteInformation from "@/views/InfoEmail/EmailResponseOTR/components/cannedResponsesTables/dedicated/QuoteInformation.vue";
import { missingFieldsAlert } from "@/api/errorMessages";
import FreightDetails from "@/views/InfoEmail/EmailResponseOTR/components/cannedResponsesTables/dedicated/FreightDetails.vue";
import modesByDepartment from "../../../utils/OTR/modesByDepartment";

export default {
  name: "EmailResponse",
  props: {
    tripsComponent: Object
  },
  components: {
    Rate,
    Accessorials,
    FreightDetails,
    QuoteInformation,
    FroalaEditor
  },
  data() {
    return {
      messageBody: "",
      newContent: "",
      responses: null,
      listsType: null,
      cannedResponseSelected: null,
      copyTo: [],
      email: null,
      haulInformation: null,
      thereIsEmails: false,
      quoteById: null,
      busy: false,
      totalHuCountAux: null,
      isEmail: false,
      commodityAux: [],
      cannedTablesArray: [],
      cannedResponseTableOptions: null,
      ftlQuoteTableInfo: [],
      thereIsDedicatedQuoteInfo: false,
      showFtlTable: false,
      renderFtlTable: 0,
      ftlQuoteMode: [],
      currentDepartment: null,
      currentCannedResponse: null,
      selectedMode: null
    };
  },
  computed: {
    ...mapGetters("quotes/quote", ["showSelectedMode"])
  },
  watch: {
    async showSelectedMode(value) {
      this.cannedResponseSelected = "";
      this.selectedMode = value;
      this.getResponsesFromCanned();
    },
    async cannedResponseSelected() {
      if (this.cannedResponseSelected) {
        const validationCannedSelected = await this.validateCannedSelected();
        this.currentCannedResponse = null;

        this.busy = true;
        if (validationCannedSelected) {
          await this.getCannedResponseById();
          let quoteId = this.$route.params.id;
          await this.$store.dispatch("quotes/quote/getQuote", quoteId);
          this.quoteById = await this.$store.getters[
            "quotes/quote/showQuoteById"
          ];
          this.haulInformation = this.$store.getters[
            "quotes/quote/showQuoteById"
          ].haul;
          let counterTmsMode = 0;
          for (let i in this.haulInformation) {
            if (!this.haulInformation[i]?.tms_mode?.name) {
              counterTmsMode++;
            }
          }
          if (counterTmsMode == 0 && this.haulInformation.length > 0) {
            if (!this.cannedResponseSelected) {
              this.cannedTablesArray = [];
            }
            this.$emit(
              "getCannedResponseSelected",
              this.cannedResponseSelected
            );
            this.loadListType();
            this.newContent = "";

            if (this.currentCannedResponse) {
              if (
                this.cannedResponseSelected === this.currentCannedResponse.name
              ) {
                if (this.currentCannedResponse?.aditionals?.freightDetails) {
                  this.getcannedResponseTableOptions();
                  await this.getFtlQuote();
                } else if (
                  this.currentCannedResponse?.aditionals?.accessorialTable
                ) {
                  await this.getDrayageList();
                } else {
                  await this.getSpecialServicesList();
                }
              }
              this.busy = false;
              this.returnResponse();
            }
          } else {
            this.cannedResponseSelected = "";
            missingFieldsAlert("Please, select a Mode!.");
          }
        } else {
          this.newContent = "";
        }
      } else {
        this.newContent = "";
      }
      this.busy = false;
    },
    messageBody() {
      this.returnResponse();
    }
  },
  async mounted() {
    this.quoteById = await this.$store.getters["quotes/quote/showQuoteById"];
    this.email = this.quoteById.message.client_email;
    if (
      this.$route.params.pathName == "failed" &&
      this.quoteById.message.html_response
    ) {
      let stringStart = `<table style="box-sizing:content-box;border-collapse:collapse;margin-left:0px!important" cellspacing="0" cellpadding="0" border="0">`;
      let stringEnd = `</table>`;
      let start = this.quoteById.message.html_response.indexOf(stringStart);
      let end =
        this.quoteById.message.html_response.lastIndexOf(stringEnd) +
        stringEnd.length;
      let messageAux =
        this.quoteById.message.html_response.substring(0, start) +
        "" +
        this.quoteById.message.html_response.substring(end);
      this.newContent = messageAux;
    }
    this.addEmail();
    this.returnResponse();
  },
  methods: {
    // Canned from Back
    cannedResponseTable(tableInfo) {
      if (this.cannedTablesArray.length > 0) {
        let thereIsTable = false;
        for (let i in this.cannedTablesArray) {
          if (tableInfo.tableId === this.cannedTablesArray[i].tableId) {
            this.cannedTablesArray[i] = tableInfo;
            thereIsTable = true;
            break;
          }
        }
        if (!thereIsTable) {
          this.cannedTablesArray.push(tableInfo);
        }
      } else {
        this.cannedTablesArray.push(tableInfo);
      }
      this.$emit("getCannedResponseTable", this.cannedTablesArray);
    },

    addTableHtml(tableInfo) {
      let tableInfoCopy = { ...tableInfo };
      if (this.cannedTablesArray.length > 0) {
        let thereIsTable = false;
        for (let i in this.cannedTablesArray) {
          if (tableInfoCopy.tableId === this.cannedTablesArray[i].tableId) {
            this.cannedTablesArray[i] = tableInfoCopy;
            thereIsTable = true;
            break;
          }
        }
        if (!thereIsTable) {
          this.cannedTablesArray.push(tableInfoCopy);
        }
      } else {
        this.cannedTablesArray.push(tableInfoCopy);
      }
      this.$emit("getCannedResponseTable", this.cannedTablesArray);
    },
    renderFtlTables() {
      this.thereIsDedicatedQuoteInfo = false;
    },
    async getFtlQuote() {
      this.ftlQuoteTableInfo = [];
      this.ftlQuoteMode = [];
      this.showFtlTable = true;
      // Canned from Back
      let messageBodyAux = this.currentCannedResponse?.html;
      let quoteInfoIndex =
        messageBodyAux.indexOf(`{quote_information_trip_1}</p>`) +
        `{quote_information_trip_1}</p>`.length;
      messageBodyAux = this.insertNewString(
        messageBodyAux,
        quoteInfoIndex,
        this.getAccessorials(0)
      );
      for (let i = 0; i < this.quoteById.haul.length; i++) {
        let huCountAux = await this.getTotalHuCount(i);
        let weightAux = await this.getTotalWeight(i);
        let dimensionsAux = await this.getDedicatedTableDimensions(i);
        let commodityAux = this.getDedicatedTableCommodity(i);
        // Canned from Back
        let elementQuoteTableInfo = [
          {
            value: `${this.quoteById.haul[i].city_from}, ${this.quoteById.haul[i].state_from} - ${this.quoteById.haul[i].zip_from}`
          },
          {
            value: `${this.quoteById.haul[i].city_to}, ${this.quoteById.haul[i].state_to} - ${this.quoteById.haul[i].zip_to}`
          },
          { value: huCountAux },
          { value: weightAux },
          { value: dimensionsAux },
          { value: commodityAux }
        ];
        this.ftlQuoteTableInfo[i] = elementQuoteTableInfo;

        this.ftlQuoteMode.push(this.quoteById.haul[i].tms_mode.name);
      }
      let lists = "";
      for (let trip in this.listsType[this.cannedResponseSelected]) {
        lists = lists + this.listsType[this.cannedResponseSelected][trip];
      }
      if (this.haulInformation.length > 1) {
        let tableStringsBlock = `<br><p>{freight_details_trip_2}</p><br><p>{quote_information_trip_2}</p>`;
        let quoteInfoString = `--ACCESSORIALS_PER_TRIP--`;
        let infoString;
        if (messageBodyAux.includes(`<p>--ACCESSORIALS_PER_TRIP--</p>`)) {
          infoString = `<p>--ACCESSORIALS_PER_TRIP--</p>`;
        } else {
          const keyInfoString = [
            "<p><b>Información Importante:</b></p>",
            "<p><strong>Información Importante:</strong></p>",
            `<p><b>Important Information:</b></p>`,
            "<p><strong>Important Information:</strong></p>"
          ];
          [infoString] = keyInfoString?.filter(text =>
            messageBodyAux.includes(text)
          );
        }
        for (let i = 1; i < this.haulInformation.length; i++) {
          let tableStringsAndAccessorials =
            tableStringsBlock +
            (infoString === `<p>--ACCESSORIALS_PER_TRIP--</p>`
              ? this.getAccessorials(i)
              : "");
          let quoteInfoStringIndex = messageBodyAux.indexOf(infoString);
          messageBodyAux = this.insertNewString(
            messageBodyAux,
            quoteInfoStringIndex,
            tableStringsAndAccessorials
          );
          tableStringsBlock = tableStringsBlock.replaceAll(i + 1, i + 2);
          if (infoString === `<p>--ACCESSORIALS_PER_TRIP--</p>`) {
            quoteInfoString = quoteInfoString.replace(i, i + 1);
          }
        }
      }
      const stringtoReplace = !modesByDepartment.TCModes.includes(
        this.selectedMode
      )
        ? "--ACCESSORIALS_PER_TRIP--"
        : "<p>--ACCESSORIALS_PER_TRIP--</p><p><br></p>";
      messageBodyAux = messageBodyAux.replace(stringtoReplace, "<br>");
      this.newContent = messageBodyAux;
      this.thereIsDedicatedQuoteInfo = true;
    },
    getDrayageList() {
      this.showFtlTable = false;
      // Canned from Back
      let messageBodyAux = this.currentCannedResponse?.html;
      messageBodyAux = messageBodyAux.replace(`SHP: `, "");

      // Canned from Front
      messageBodyAux = messageBodyAux.replace(
        `{shp_table_rate_1}`,
        this.haulInformation[0].id
      );
      let tableRateString;
      let tableRateStringFromTo;
      const cannedLanguageFrom = this.cannedResponseSelected
        .toLowerCase()
        .includes("español")
        ? "Desde:"
        : "From:";
      const cannedLanguageTo = this.cannedResponseSelected
        .toLowerCase()
        .includes("español")
        ? "Hasta:"
        : "To:";
      if (!cannedLanguageFrom && !cannedLanguageTo) return;
      const keyFromTo = [
        `<p><b>${cannedLanguageFrom}</b></p><p><b>${cannedLanguageTo}</b></p><p>{table_rate_1}</p>`,
        `<p><strong>${cannedLanguageFrom}</strong></p><p><strong>${cannedLanguageTo}</strong></p><p>{table_rate_1}</p>`
      ];
      const [resultRateString] = keyFromTo.filter(text =>
        messageBodyAux.includes(text)
      );
      if (modesByDepartment.TCModes.includes(this.selectedMode)) {
        tableRateString = `<p><b>${cannedLanguageFrom}</b></p><p><b>${cannedLanguageTo}</b></p><p>{table_rate_1}</p>`;
        tableRateStringFromTo = `<p><strong>${cannedLanguageFrom}</strong>&nbsp; ${this.haulInformation[0].city_from}, ${this.haulInformation[0].state_from} - ${this.haulInformation[0].zip_from}</p><p><strong>${cannedLanguageTo}</strong> ${this.haulInformation[0].city_to}, ${this.haulInformation[0].state_to} - ${this.haulInformation[0].zip_to}</p><p>{table_rate_1}</p><br>`;
      } else {
        tableRateString = resultRateString;
        tableRateStringFromTo = `<p><strong>${cannedLanguageFrom}</strong>&nbsp; ${this.haulInformation[0].city_from}, ${this.haulInformation[0].state_from} - ${this.haulInformation[0].zip_from}</p><p><strong>${cannedLanguageTo}</strong> ${this.haulInformation[0].city_to}, ${this.haulInformation[0].state_to} - ${this.haulInformation[0].zip_to}</p><p>{table_rate_1}</p><br>`;
      }
      messageBodyAux = messageBodyAux.replace(
        tableRateString,
        tableRateStringFromTo
      );
      if (this.haulInformation.length > 1) {
        for (let i = 1; i < this.haulInformation.length; i++) {
          let newShp = `<p><b>{shp_table_rate_${i + 1}}</b></p>`;
          let tableStringIndex =
            messageBodyAux.indexOf(tableRateStringFromTo) +
            tableRateStringFromTo.length;
          tableRateStringFromTo = `<p><strong>${cannedLanguageFrom}</strong>&nbsp; ${
            this.haulInformation[i].city_from
          }, ${this.haulInformation[i].state_from} - ${
            this.haulInformation[i].zip_from
          }</p><p><strong>${cannedLanguageTo}</strong> ${
            this.haulInformation[i].city_to
          }, ${this.haulInformation[i].state_to} - ${
            this.haulInformation[i].zip_to
          }</p><p>{table_rate_${i + 1}}</p><p><br></p>`;
          messageBodyAux = this.insertNewString(
            messageBodyAux,
            tableStringIndex,
            tableRateStringFromTo
          );
          messageBodyAux = this.insertNewString(
            messageBodyAux,
            messageBodyAux.indexOf(tableRateStringFromTo),
            newShp
          );
          messageBodyAux = messageBodyAux.replace(
            `{shp_table_rate_${i + 1}}`,
            this.haulInformation[i].id
          );
        }
      }
      for (let i = 0; i < this.quoteById.haul.length; i++) {
        this.listsType[this.cannedResponseSelected].push(
          `<b>${this.quoteById.haul[i].id}`
        );
      }
      let lists = "";
      for (let trip in this.listsType[this.cannedResponseSelected]) {
        lists = lists + this.listsType[this.cannedResponseSelected][trip];
      }
      this.newContent = messageBodyAux.replace(
        "<b>---FREIGHT-DETAILS-HERE---</b><br><br>",
        lists
      );
    },
    async getNormalList() {
      this.showFtlTable = false;
      // Canned from Back
      let messageBodyAux = this.currentCannedResponse?.html;

      // Canned from Front
      for (let i = 0; i < this.quoteById.haul.length; i++) {
        let huCountAux = await this.getTotalHuCount(i);
        let weightAux = await this.getTotalWeight(i);
        let dimensionsAux = await this.getDimensions(i);
        let commodityAux = this.getCommodity(i);
        this.listsType[this.cannedResponseSelected].push(
          `<b>${
            this.quoteById.haul[i].id
          }</b><br><b style='color: #17A2B8;'>--- FREIGHT DETAILS TRIP ${i +
            1} ---</b><ul><li><b>Origin:</b> ${
            this.quoteById.haul[i].city_from
          }, ${this.quoteById.haul[i].state_from} - ${
            this.quoteById.haul[i].zip_from
          }</li><li><b>Destination:</b> ${this.quoteById.haul[i].city_to}, ${
            this.quoteById.haul[i].state_to
          } - ${
            this.quoteById.haul[i].zip_to
          }</li><li><b>Number of pieces:</b> ${huCountAux}</li><li><b>Total weight:</b> ${weightAux}</li><li><b>Dimensions:</b></li>${dimensionsAux}<li><b>Commodity:</b></li>${commodityAux}</ul><br>`
        );
      }
      let lists = "";
      for (let trip in this.listsType[this.cannedResponseSelected]) {
        lists = lists + this.listsType[this.cannedResponseSelected][trip];
      }
      this.newContent = messageBodyAux.replace(
        "<b>---FREIGHT-DETAILS-HERE---</b><br><br>",
        lists
      );
    },
    async getSpecialServicesList() {
      this.showFtlTable = false;
      // Canned from Back
      let messageBodyAux = this.currentCannedResponse?.html;

      // Canned from Front
      for (let i = 0; i < this.quoteById.haul.length; i++) {
        let huCountAux = await this.getTotalHuCount(i);
        let weightAux = await this.getTotalWeight(i);
        let dimensionsAux = await this.getDimensions(i);
        let volumeAux = this.$store.getters["totals/showTotalDensityAndVolume"];
        let commodityAux = this.getCommodity(i);
        this.listsType[this.cannedResponseSelected].push(
          `<b>${
            this.quoteById.haul[i].id
          }</b><br><b style='color: #17A2B8;'>--- FREIGHT DETAILS TRIP ${i +
            1} ---</b><ul><li><b>Origin:</b> ${
            this.quoteById.haul[i].city_from
          }, ${this.quoteById.haul[i].state_from} - ${
            this.quoteById.haul[i].zip_from
          }</li><li><b>Destination:</b> ${this.quoteById.haul[i].city_to}, ${
            this.quoteById.haul[i].state_to
          } - ${
            this.quoteById.haul[i].zip_to
          }</li><li><b>Number of pieces:</b> ${huCountAux}</li><li><b>Total Weight (lbs):</b> ${weightAux}</li><li><b>Dimensions (inches):</b></li>${dimensionsAux}<li><b>Volume: </b>${volumeAux}</li><li><b>Commodity:</b></li>${commodityAux}</ul><br>`
        );
      }
      let lists = "";
      for (let trip in this.listsType[this.cannedResponseSelected]) {
        lists = lists + this.listsType[this.cannedResponseSelected][trip];
      }
      this.newContent = messageBodyAux.replace(
        "---FREIGHT-DETAILS-HERE---",
        lists
      );
    },
    getAccessorials(i) {
      let accessorialsPerTrip = `<br><p><strong>Accessorials Trip ${i +
        1}:</strong></p><ul>`;
      let indexHazmat = this.quoteById.haul[i].accessorial.indexOf("Hazmat");
      if (indexHazmat == -1) {
        accessorialsPerTrip = accessorialsPerTrip + `<li>Non Hazmat</li>`;
      }
      if (this.quoteById.haul[i].accessorial.length > 0) {
        for (let j in this.quoteById.haul[i].accessorial) {
          accessorialsPerTrip =
            accessorialsPerTrip +
            `<li>${this.quoteById.haul[i].accessorial[j].accessorial.name}</li>`;
        }
      }
      accessorialsPerTrip = accessorialsPerTrip + `</ul>`;
      return accessorialsPerTrip;
    },
    async getTotalHuCount(i) {
      this.totalHuCountAux = [];
      for (let item of this.quoteById.haul[i].commodity) {
        if (item.hu_count != null && item.hu_count != "") {
          this.totalHuCountAux.push(item.hu_count);
        }
      }
      let info = {};
      info.hu_count = this.totalHuCountAux;
      let response = await this.$store.dispatch("totals/getTotalHuCount", info);
      let totalHu = response.data.split(" ")[0];
      return totalHu;
    },
    async getTotalWeight(i) {
      let totalWeightAux = [];
      for (let item of this.quoteById.haul[i].commodity) {
        if (item.weight != null && item.weight != "") {
          totalWeightAux.push(item.weight);
        }
      }
      let info = {};
      info.hu_count = this.totalHuCountAux;
      info.weight = totalWeightAux;
      let response = await this.$store.dispatch("totals/getTotalWeight", info);
      return response.data;
    },
    getDedicatedTableDimensions(i) {
      let totalDimensions = [];
      for (let item of this.quoteById.haul[i].commodity) {
        if (item.dimensions != null && item.dimensions != "") {
          totalDimensions.push(item.dimensions);
        }
      }
      return totalDimensions;
    },
    getDimensions(i) {
      let totalDimensionsAux = `<ul>`;
      for (let item of this.quoteById.haul[i].commodity) {
        if (item.dimensions != null && item.dimensions != "") {
          totalDimensionsAux =
            totalDimensionsAux + `<li>${item.dimensions}</li>`;
        }
      }
      totalDimensionsAux = totalDimensionsAux + `</ul>`;
      return totalDimensionsAux;
    },
    getDedicatedTableCommodity(haul) {
      let commodities = this.quoteById.haul[haul].commodity.map(el => {
        if (!el.description) {
          return "";
        }
        return el.description;
      });
      return commodities;
    },
    getCommodity(haul) {
      this.commodityAux = [];
      let commodity = `<ul>`;
      this.quoteById.haul[haul].commodity.map(el => {
        if (el.description) {
          commodity = commodity + `<li>${el.description}</li>`;
          this.commodityAux.push(el.description);
        }
      });
      commodity = commodity + `</ul>`;
      return commodity;
    },
    getSpecs(i) {
      let specs = `<ul>`;
      for (let item of this.quoteById.haul[i].commodity) {
        specs =
          specs +
          `<li>${item.hu_count}, ${item.dimensions}, ${item.weight}</li>`;
      }
      specs = specs + `</ul>`;
      return specs;
    },
    async returnResponse() {
      let responseEmail = {};
      responseEmail.messageBody = this.messageBody;
      let emailsCopy = "";
      for (let i = 0; i < this.copyTo.length; i++) {
        emailsCopy = emailsCopy + this.copyTo[i] + ",";
      }
      if (emailsCopy.slice(-1) == ",") {
        let emailsCopyAux = emailsCopy.slice(0, -1);
        responseEmail.emails = emailsCopyAux;
      } else {
        responseEmail.emails = emailsCopy;
      }
      let info = {
        messageId: this.quoteById.message.id,
        body: {
          client_email: responseEmail.emails
        }
      };
      await this.$store.dispatch("quotes/updateMessage", info);
      return this.$emit("input", responseEmail);
    },
    insertNewString(string, index, value) {
      return string.substr(0, index - 1) + value + string.substr(index);
    },
    addEmail() {
      let verifyEmail = this.validateEmail(this.email);
      if (verifyEmail) {
        this.copyTo.push(this.email);
        this.email = null;
        this.thereIsEmails = true;
        this.returnResponse();
      }
    },
    validateEmail(mail) {
      if (mail != null && mail != undefined && mail != "") {
        if (
          /^.*[a-zA-Z0-9.ñ!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\.[a-zA-Z0-9-]+)*$/.test(
            mail
          )
        ) {
          this.isEmail = true;
          return true;
        }
        this.isEmail = false;
        return false;
      } else {
        this.isEmail = true;
      }
    },
    deleteEmail(index) {
      this.copyTo.splice(index, 1);
      if (this.copyTo.length == 0) {
        this.thereIsEmails = false;
      }
      this.returnResponse();
    },

    // Canned from Back
    async getResponsesFromCanned() {
      this.currentDepartment = JSON.parse(
        localStorage.getItem("current-department")
      );
      this.responses = await this.$store.dispatch(
        "cannedResponses/getCannedResponses",
        this.selectedMode
      );
      let copyResponses;
      if (this.responses !== 400) {
        if (modesByDepartment.TCModes.includes(this.selectedMode)) {
          copyResponses = this.responses.filter(
            response => response.name !== "DRAYAGE_QUOTE_NY"
          );
          this.responses = [...copyResponses];
        }
        for (let element of this.responses) {
          element.name = element.name.replace(/_/g, " ");
        }
        this.loadListType();
      }
    },

    // Canned from Back
    async validateCannedSelected() {
      let validationCannedSelected = false;
      this.responses.forEach(element => {
        if (element.name === this.cannedResponseSelected) {
          this.cannedId = element.id;
          validationCannedSelected = true;
        }
      });
      return validationCannedSelected;
    },
    async getCannedResponseById() {
      const info = {
        canned_id: this.cannedId,
        mode_name: this.selectedMode
      };
      if (this.cannedResponseSelected) {
        const response = await this.$store.dispatch(
          "cannedResponses/getCannedResponseById",
          info
        );
        if (response.status === 200) {
          this.currentCannedResponse = response?.data;
        }
      }
    },
    getcannedResponseTableOptions() {
      if (this.currentCannedResponse?.aditionals?.rates) {
        this.cannedResponseTableOptions = this.currentCannedResponse?.aditionals?.rates?.tables;
      }
    },
    loadListType() {
      this.listsType = {};
      this.responses.forEach(response => (this.listsType[response.name] = []));
    }
  }
};
</script>

<style lang="scss" scoped>
.email-response {
  @include card;
  margin: $margin-most-used;
  padding: 20px;
  &--red-alert {
    width: 100% !important;
    color: red;
    font-size: 12px;
    margin-top: $margin-most-used / 2;
    @include flex-wrap(flex-start);
  }
  &__copy-to-content {
    text-align: left;
    margin-top: $margin-most-used / 2;
    &--email {
      display: inline-block;
      margin-top: $margin-most-used/3;
      background-color: rgba(253, 143, 59, 0.2);
      border-radius: 30px;
      padding: 3px 7px;
      font-size: 13px;
      margin-right: 10px;
    }
    &--close-email {
      @include close-button(rgba(253, 143, 59, 0.2));
      font-size: 12px;
    }
  }

  &--canned-responses {
    margin-top: 10px;
  }

  &__body-message {
    margin-top: 20px;
  }
}

.drayage-tables-container {
  display: flex;
  flex-wrap: wrap;
}

.ftl-tables-container {
  display: flex;
  &__title {
    margin: 0px;
    margin-top: 10px;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
  }
  &__tables-per-trip {
    margin-right: 20px;
  }
}

::v-deep .p-editor-container {
  .p-editor-toolbar {
    background-color: $color-background-input !important;
    display: flex;
    justify-content: flex-start;
  }
  .ql-editor {
    text-align: justify !important;
  }
}
</style>
